export default __webpack_public_path__ + "static/media/brand_visa.8ac2aa3f.svg";